export const VIEW_MAP = 'map';
export const VIEW_TABLE = 'table';
